import {
  ArrowRightLeft,
  Clock,
  Clock3,
  Coins,
  MessageCircle,
  Repeat,
  ShieldAlert,
} from "lucide-react";

import { Card } from "@/components/ui/card";
import type { UserProfile } from "@/interfaces/profile";
import { useUserReputationScore } from "@/hooks";
import { formatCurrency } from "@/utils/formatCurrency";

interface MerchantStatsProps {
  merchantId: string;
}

export default function MerchantStats({ merchantId }: MerchantStatsProps) {
  const { data: userScore } = useUserReputationScore(merchantId || "");

  const averageResponseTime = (
    Number(userScore?.averageResponseTime) / 60
  ).toFixed(2);

  const stats = [
    {
      label: "Average Release",
      value: userScore?.averageReleaseTime + " minutes",
      icon: Clock3,
      hint: "Time to release crypto",
    },
    {
      label: "Average Response",
      value: averageResponseTime + " minutes",
      icon: MessageCircle,
      hint: "First response to buyer",
    },
    {
      label: "30 Day Trades",
      value: userScore?.completedTrades30d,
      icon: ArrowRightLeft,
      hint: "Completed this month",
    },
    {
      label: "Trade Volume",
      type: "trade",
      value: formatCurrency(userScore?.tradeVolume ?? 0),
      icon: Coins,
      hint: "Lifetime trading volume",
    },
    {
      label: "Repeat Customers",
      value: `${userScore?.repeatCustomersCount}`,
      icon: Repeat,
      hint: "Returning traders",
    },
    {
      label: "Dispute Rate",
      value: `${userScore?.disputeRate}%`,
      icon: ShieldAlert,
      hint: "Orders ending in dispute",
    },
    {
      label: "Payment Window",
      value: "15 Minutes",
      icon: Clock,
      hint: "Payment windo",
    },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {stats.map((stat) => {
        const Icon = stat.icon;

        return (
          <Card
            key={stat.label}
            className="rounded-2xl transition-all duration-200 hover:shadow-md hover:border-primary/30"
          >
            <div className="p-5">
              <div className="flex items-center justify-between">
                <div className="space-y-1">
                  <p className="text-sm text-muted-foreground">{stat.label}</p>

                  <h2 className="text-2xl font-bold">
                    {" "}
                    {stat.type === "trade" && "$"} {stat.value}
                  </h2>

                  <p className="text-xs text-muted-foreground">{stat.hint}</p>
                </div>

                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                  <Icon className="h-6 w-6 text-primary" />
                </div>

                {/* <div className="absolute -right-5 -top-5 opacity-5">
                  <Icon className="h-24 w-24" />
                </div> */}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
